import inventory from '@/api/report-inventory'
import location from '@/api/warehouse'
import product from '@/api/product'
import productLocation from '@/api/product-location'
import branch from '@/api/branch'
import User from '@/api/users'
import StockTransfer from '@/api/stock-transfer'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  }
}

export const actions = {
  getBranch(context, attributes = {}) {
    return branch.get({
      params: {
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLocation(context, attributes = {}) {
    return location.get({
      params: attributes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getProductProfile(context, attributes = {}) {
    return product.get({
      params: attributes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getProduct(context, attributes = {}) {
    return productLocation.get({
      params: attributes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getCashier(context, attributes = {}) {
    return User.get({
      params: {
        include: 'employee',
        filter: {
          cashier_location_id: attributes.cashier_location_id
        },
        fields: {
          sys_user: 'user_id,loginname,staff_id'
        },
        page: -1,
        ...attributes
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getTransferNumber(context, attributes = {}) {
    return StockTransfer.get({
      params: {
        fields: {
          inventory_stock_transfer_managements: 'stock_transfer_id,trans_number'
        },
        filter: {
          filter_date: true
        },
        page: -1,
        ...attributes
      },

      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  // generate daily sale item pdf
  dailySaleItem(context, payload) {
    return inventory.dailySaleItem(payload)
  },
  // generate daily sale item excel
  dailySaleItemExcel(context, payload) {
    return inventory.dailySaleItemExcel(payload)
  },
  // generate sale item details
  saleItemDetail(context, attributes) {
    return inventory.saleItemDetail(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    )
  },
  // generate sale item detail as excel
  saleItemDetailExcel(context, payload) {
    return inventory.saleItemDetailExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  },
  // generate stock in detail as pdf
  stockInDetail(context, payload) {
    return inventory.stockInDetail(payload)
  },
  // generate stock in detail as excel
  stockInDetailExcel(context, payload) {
    return inventory.stockInDetailExcel(payload)
  },
  // generate stock in summary
  stockInSummary(context, payload) {
    return inventory.stockInSummary(payload)
  },
  // generate stock in summary
  stockInSummaryExcel(context, payload) {
    return inventory.stockInSummaryExcel(payload)
  },
  // generate detail inventory list
  detailInventoryList(context, payload) {
    return inventory.detailInventoryList(payload)
  },
  // generate detail inventory list as excel
  detailInventoryListExcel(context, payload) {
    return inventory.detailInventoryListExcel(payload)
  },
  // generate summary inventory list
  summaryInventoryList(context, payload) {
    return inventory.summaryInventoryList(payload)
  },
  // generate summary inventory list as excel
  summaryInventoryListExcel(context, payload) {
    return inventory.summaryInventoryListExcel(payload)
  },
  // generate product item list
  productItemList(context, payload) {
    return inventory.productItemList(payload)
  },
  // generate purchase order list
  purchaseOrderList(context, payload) {
    return inventory.purchaseOrderList(payload)
  },
  // generate purchase order list
  purchaseOrderSummary(context, payload) {
    return inventory.purchaseOrderSummary(payload)
  },
  // generate monthly sale item
  monthlySaleItem(context, payload) {
    return inventory.monthlySaleItem(payload)
  },
  // generate monthly sale item as excel
  monthlySaleItemExcel(context, payload) {
    return inventory.monthlySaleItemExcel(payload)
  },
  // generate stock transfer
  stockTransfer(context, payload) {
    return inventory.stockTransfer(payload)
  },
  // generate monthly sale item as excel
  stockTransferExcel(context, payload) {
    return inventory.stockTransferExcel(payload)
  },
  // generate yearly sale items
  yearlySaleItem(context, payload) {
    return inventory.yearlySaleItem(payload)
  },
  // generate inventory List Head Office
  inventoryListHeadOffice(context, attributes = {}) {
    return inventory.inventoryListHeadOffice({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // generate inventory List Head Office list as excel
  inventoryListHeadOfficeExcel(context, payload) {
    return inventory.inventoryListHeadOfficeExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  }
}
